<template>
  <div class="chosen-products-list">
    <div class="page-title">
      <icon-base
        :width="32"
        :height="33"
        :viewBox1="32"
        :viewBox2="33"
        iconName="chart"
        iconColor="transparent"
        ><icon-chart-histogram
      /></icon-base>
      <div class="page-title__text">
        <h1>Stimuli</h1>
        <span>Upload Test Images</span>
      </div>
    </div>

    <div class="box-wrapper">
      <StimuliTitle :title="stimuliTitle"></StimuliTitle>
      <a-row :gutter="16" v-show="hideDetails">
        <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
          <ActiveShelf
            :activeShelf="activeShelf"
            :surveyType="surveyType"
            @editShelf="$emit('editShelf')"
          ></ActiveShelf
        ></a-col>
        <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
          <SelectedProducts
            :selectedProducts="chosenProductsList"
            :surveyType="surveyType"
            @editSelectedProducts="$emit('prevStep')"
          ></SelectedProducts
        ></a-col>
      </a-row>

      <div class="flex items-center justify-between">
        <a-tooltip placement="top" overlayClassName="ant-tooltip--step-nav">
          <template slot="title" v-if="findEmptyData.length > 0">
            To add Test {{ getFirstZonePackLength }} you need to fill all
            required fields for Test that you already added.
          </template>
          <a-button
            @click="addCell"
            type="primary"
            :disabled="findEmptyData.length > 0"
            >Add Test {{ getFirstZonePackLength }}</a-button
          >
        </a-tooltip>
        <p
          class="cursor-pointer font-size-14 mb-0"
          @click="imageRequirementsModal = true"
          v-if="studyType !== 'SBD'"
        >
          <a-icon type="info-circle" class="mr-5" /> Image Requirements
        </p>
      </div>

      <div class="chosen-products-list__wrapper">
        <div
          class="chosen-products-list__row"
          :class="{
            'chosen-products-list__row--hide-line':
              productsDetailsInfo.zones[0].packs.length < 2,
          }"
          v-for="(item, index) in productsDetailsInfo.zones"
          :key="item.ZoneID"
        >
          <div
            v-for="(pack, itemIndex) in item.packs"
            :key="itemIndex"
            class="position-r"
          >
            <div
              class="chosen-products-list__delete-test"
              v-if="
                index === 0 &&
                pack.FriendlyName !== 'Control' &&
                !pack.IsOldShelf
              "
              @click="deleteProductInfo(itemIndex)"
            >
              <a-tooltip
                placement="top"
                overlayClassName="ant-tooltip--step-nav"
              >
                <template slot="title"> Delete Test {{ itemIndex }} </template>
                <icon-base
                  @mouseover="activeColumn = itemIndex"
                  @mouseout="activeColumn = null"
                  :width="48"
                  :height="48"
                  :viewBox1="48"
                  :viewBox2="48"
                  iconName="delete"
                  ><icon-delete
                /></icon-base>
              </a-tooltip>
            </div>

            <EditProductItemNew
              :productInfo="pack"
              :unEncryptSurveyId="unEncryptSurveyId"
              :index="itemIndex"
              @input="setProductInfo($event, index, itemIndex)"
              @delete="deleteProductInfo(index, itemIndex)"
              @image-requirements-modal="imageRequirementsModal = true"
              @close-product-item="activeLegId = null"
            ></EditProductItemNew>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between stimuli-nav">
      <a-button @click="$emit('prevStep')"
        ><icon-base
          class="ml-5 back"
          :width="20"
          :height="20"
          :viewBox1="20"
          :viewBox2="20"
          iconName="longArrowRight"
          iconStroke="#D04395"
          ><icon-long-arrow-right
        /></icon-base>
        Back</a-button
      >
      <a-button
        type="primary"
        @click="$emit('nextStep')"
        class="flex justify-center items-center"
      >
        <i class="circle-loader" v-if="loading"></i>

        <div v-else>
          Next

          <icon-base
            class="ml-5"
            :width="20"
            :height="20"
            :viewBox1="20"
            :viewBox2="20"
            iconName="longArrowRight"
            iconStroke="#fff"
            ><icon-long-arrow-right
          /></icon-base></div
      ></a-button>
    </div>
    <a-modal
      title="Image Requirements"
      :visible="imageRequirementsModal"
      @cancel="imageRequirementsModal = false"
      :width="920"
    >
      <div class="image-requirements">
        <div class="image-requirements__row">
          <p>
            1. The width or height of the image should be at least 800px (based
            on product shape)
          </p>
          <a-row :gutter="16" class="flex">
            <a-col :span="6"
              ><div class="image-requirements__item">
                <div class="image-requirements__item-category">
                  Square Shape
                </div>
                <a
                  href="/images/imageRequirements/s_product.jpeg"
                  target="_blank"
                >
                  <div class="image-requirements__item-image">
                    <img
                      src="/images/imageRequirements/s_product.jpeg"
                      alt=""
                    />
                  </div>
                  <p>Click the image to see large version</p>
                </a>
                <div class="flex image-requirements__item-dimensions">
                  <span class="flex-1">Width: 1000px</span>
                  <span class="flex-1">Height: 1000px</span>
                </div>
              </div></a-col
            >
            <a-col :span="6"
              ><div class="image-requirements__item">
                <div class="image-requirements__item-category">
                  Horizontal Rectangle Shape
                </div>
                <a
                  href="/images/imageRequirements/horizontal.jpeg"
                  target="_blank"
                >
                  <div class="image-requirements__item-image">
                    <img
                      src="/images/imageRequirements/horizontal.jpeg"
                      alt=""
                    />
                  </div>
                  <p>Click the image to see large version</p></a
                >
                <div class="flex image-requirements__item-dimensions">
                  <span class="flex-1">Width: 1000px</span>
                  <span class="flex-1">Height: 500px</span>
                </div>
              </div></a-col
            >
            <a-col :span="6"
              ><div class="image-requirements__item">
                <div class="image-requirements__item-category">
                  Vertical Rectangle Shape
                </div>
                <a
                  href="/images/imageRequirements/vertical.jpeg"
                  target="_blank"
                >
                  <div class="image-requirements__item-image">
                    <img src="/images/imageRequirements/vertical.jpeg" alt="" />
                  </div>
                  <p>Click the image to see large version</p></a
                >
                <div class="flex image-requirements__item-dimensions">
                  <span class="flex-1">Width: 1000px</span>
                  <span class="flex-1">Height: 500px</span>
                </div>
              </div></a-col
            >
            <a-col :span="6"
              ><div
                class="image-requirements__item image-requirements__item--red"
              >
                <div class="image-requirements__item-category">Bad Example</div>
                <a
                  href="/images/imageRequirements/badQuality.png"
                  target="_blank"
                >
                  <div class="image-requirements__item-image">
                    <img
                      src="/images/imageRequirements/badQuality.png"
                      style="max-width: 45%"
                      alt=""
                    />
                  </div>
                  <p>Click the image to see large version</p></a
                >
                <div class="flex image-requirements__item-dimensions">
                  <span class="flex-1">Width: 300px</span>
                  <span class="flex-1">Height: 300px</span>
                </div>
              </div></a-col
            >
          </a-row>
        </div>
        <div class="image-requirements__row">
          <p>
            2. The product image should be front-facing, sharp and of good
            quality. Typically, larger file sizes mean better resolution.
          </p>
          <a-row :gutter="16" class="flex">
            <a-col :span="6"
              ><div class="image-requirements__item">
                <div class="image-requirements__item-category">
                  Good Example
                </div>

                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/s_product.jpeg"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/s_product.jpeg" alt="" />
                </a></div
            ></a-col>
            <a-col :span="6"
              ><div
                class="image-requirements__item image-requirements__item--red"
              >
                <div class="image-requirements__item-category">
                  Image with watermark
                </div>
                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/watermark.png"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/watermark.jpeg" alt="" />
                </a></div
            ></a-col>
            <a-col :span="6"
              ><div
                class="image-requirements__item image-requirements__item--red"
              >
                <div class="image-requirements__item-category">
                  Blurry image
                </div>
                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/blurry.jpeg"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/blurry.jpeg" alt="" />
                </a></div
            ></a-col>
            <a-col :span="6"
              ><div
                class="image-requirements__item image-requirements__item--red"
              >
                <div class="image-requirements__item-category">
                  Angled Image
                </div>
                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/angled.jpeg"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/angled.jpeg" alt="" />
                </a></div
            ></a-col>
          </a-row>
          <h2>Image size</h2>
          <p class="font-size-14 mb-0">
            While some simple packs will look good even if your image file size
            is small, it is recommended that you use image files that are
            <strong>at least 50Kb</strong>
            to avoid quality bias and to ensure consistency across packs on the
            shelf.
          </p>
        </div>
        <div class="image-requirements__row">
          <p>
            3. The product image should be saved in "png" format with a
            transparent background.
          </p>
          <p class="font-size-14 mb-20">
            Providing image files with a transparent background allows the shelf
            to be assembled without human interaction. If the images CAN'T be
            provided in the required format, our QA processes will catch the
            issue and images can be sourced or optimized manually at an
            additional cost.
          </p>
          <a-row :gutter="16" class="flex">
            <a-col :span="12"
              ><div
                class="image-requirements__item image-requirements__item--transparent-info"
              >
                <div class="image-requirements__item-category">
                  Image with transparent background
                </div>
                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/woBG.png"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/woBG.png" alt="" />
                </a></div
            ></a-col>
            <a-col :span="12"
              ><div
                class="image-requirements__item image-requirements__item--red image-requirements__item--transparent-info"
              >
                <div class="image-requirements__item-category">
                  Image without transparent background
                </div>
                <a
                  class="image-requirements__item-image"
                  href="/images/imageRequirements/withBG.jpeg"
                  target="_blank"
                >
                  <img src="/images/imageRequirements/withBG.jpeg" alt="" />
                </a></div
            ></a-col>
          </a-row>
        </div>
      </div>
      <template #footer>
        <a-button
          key="back"
          type="primary"
          @click="imageRequirementsModal = false"
          >Cancel</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script>
import EditProductItemNew from "@/components/packTestSurvey/EditProductItemNew.vue";
import ActiveShelf from "@/components/packTestSurvey/ActiveShelf.vue";
import SelectedProducts from "@/components/packTestSurvey/SelectedProducts.vue";
import StimuliTitle from "@/components/packTestSurvey/StimuliTitle.vue";
import * as wsUtils from "@/utils/wsUtils.js";
import { mutations } from "@/utils/store.js";
import IconBase from "@/components/general/IconBase.vue";
import IconChartHistogram from "@/components/icons/IconChartHistogram.vue";
import _ from "lodash";
import IconLongArrowRight from "@/components/icons/IconLongArrowRight.vue";
import IconDelete from "@/components/icons/IconDelete.vue";

const columns = [
  {
    title: "",
    scopedSlots: { customRender: "Image" },
  },
  {
    title: "Product",
    dataIndex: "productName",
  },
  {
    title: "Weight",
    dataIndex: "weight",
  },
  {
    title: "Price",
    dataIndex: "price",
  },
];

export default {
  name: "ChosenProductsList",
  components: {
    StimuliTitle,
    ActiveShelf,
    SelectedProducts,
    EditProductItemNew,
    IconBase,
    IconChartHistogram,
    IconLongArrowRight,
    IconDelete,
  },
  props: {
    chosenProductsList: {
      type: Array,
      default() {
        return [];
      },
    },
    unEncryptSurveyId: {
      type: Number,
    },
    surveyID: {
      type: String,
    },
    shelfID: {
      type: Number,
    },
    activeBrand: {
      type: String,
    },
    productsDetailsInfo: {
      type: Object,
    },
    activeShelf: {
      type: Object,
    },
    editableSurvey: {
      type: Boolean,
    },
    activeStep: {
      type: Number,
    },
    activeDeepDiveStep: {
      type: Boolean,
      default() {
        return false;
      },
    },
    surveyType: {
      type: String,
      default() {
        return null;
      },
    },
    studyType: {
      type: String,
    },
  },
  data() {
    return {
      columns,
      productsDetails: {
        SurveyId: null,
        TemplateShelfID: null,
        Brand: null,
        zones: [],
      },
      loading: true,
      imageRequirementsModal: false,
      activeLegId: null,
      activeColumn: null,
      hideDetails: false,
    };
  },
  computed: {
    getFirstZonePack() {
      let packs = [];
      if (this.productsDetailsInfo.zones[0] !== undefined) {
        packs = this.productsDetailsInfo.zones[0].packs;
      }
      return packs;
    },
    getFirstZonePackLength() {
      let packsLength = 0;
      if (this.productsDetailsInfo.zones[0] !== undefined) {
        packsLength = this.productsDetailsInfo.zones[0].packs.length;
      }
      return packsLength;
    },
    findEmptyData() {
      return _.filter(this.productsDetailsInfo.zones, {
        packs: [{ ImageURL: "" }],
      });
    },
    dlbStatus() {
      return this.surveyType === "packtestextend";
    },
    stimuliTitle() {
      return this.studyType === "SBD"
        ? "Please add the number of legs you want to test. Edit the product details to ensure the name of the product is exactly what you want the respondent to find in the findability exercise."
        : "Please add additional designs in the columns below and upload the new pack images for each product. No need to make changes to the Control version of this product. Add a new version by clicking the button 'Add Test'.";
    },
  },
  methods: {
    addCell() {
      this.productsDetails.zones.forEach((element) => {
        let lastPack = element.packs[element.packs.length - 1];
        delete lastPack.PackStimulusid;
        delete lastPack.Id;
        let newPack = {
          ...lastPack,
          FriendlyName: `Test ${element.packs.length}`,
        };
        if (this.studyType !== "SBD") {
          newPack.ImageURL = "";
        }
        delete newPack.IsOldShelf;

        element.packs.push(newPack);
      });
    },
    setProductInfo(data, rowIndex, itemIndex) {
      this.productsDetails.zones[rowIndex].packs[itemIndex] = Object.assign(
        this.productsDetails.zones[rowIndex].packs[itemIndex],
        data
      );
      this.$emit("setProductsDetails", this.productsDetails);
    },
    deleteProductInfo(itemIndex) {
      // this.productsDetails.zones[rowIndex].packs.splice(itemIndex, 1);
      // this.$emit("setProductsDetails", this.productsDetails);

      this.activeColumn = null;
      this.productsDetails.zones.forEach((item) => {
        item.packs.splice(itemIndex, 1);
      });
      this.$emit("setProductsDetails", this.productsDetails);
    },
    addDefaultZoneData(data) {
      this.chosenProductsList.forEach((item, i) => {
        let pack = {
          ImageURL: "",
          ProductName: "",
          Price: 0,
          Weight: 0,
          UPC: "",
          FriendlyName: "Control",
          FacingNum: 0,
          Notes: "",
        };

        let packsLength =
          this.productsDetails.zones.length > 0
            ? this.productsDetails.zones[0].packs.length
            : 0;

        if (data !== undefined) {
          let zone = data.find((area) => area.areaId == item.areaID);

          if (zone !== undefined) {
            pack.ProductName = zone.productName;
            pack.Weight = zone.weight;
            pack.Price = zone.price;
            pack.UPC = zone.upc;
            pack.FacingNum = zone.facingNum;
            pack.ImageURL = zone.popupURL;
          }
        }

        let product = {
          ZoneID: item.zoneId,
          AreaId: item.areaID,
          Brand: item.brandName,
          deepDive: i === 0 ? true : false,
          packs: [pack],
        };
        const index = this.productsDetails.zones.findIndex(
          (x) => x.ZoneID == item.zoneId
        );
        if (index === -1) {
          for (let i = 1; i < packsLength; i++) {
            product.packs.push({
              ImageURL: "",
              ProductName: product.packs[0].ProductName,
              Price: product.packs[0].Price,
              Weight: product.packs[0].Weight,
              UPC: product.packs[0].UPC,
              FriendlyName: `Test ${i}`,
              FacingNum: product.packs[0].FacingNum,
              Notes: "",
            });
          }
          this.productsDetails.zones.push(product);
        }
        if (this.productsDetails.zones.length === 1) {
          this.productsDetails.zones[0].deepDive = true;
        }
      });
    },
    getCSVZoneData(areaIds) {
      const randomIndetifier = Math.random();
      mutations.setCSVZoneLoader(randomIndetifier);
      const getCSVZoneData = new Promise((resolve) => {
        wsUtils.GetCSVZoneData(
          { shelfID: this.shelfID, AreaID: areaIds.toString() },
          resolve
        );
      });
      getCSVZoneData.then((data) => {
        this.addDefaultZoneData(data);
        mutations.setCSVZoneLoader(randomIndetifier);
      });
    },
  },

  updated() {
    if (this.chosenProductsList.length > 0) {
      this.productsDetails = Object.assign({}, this.productsDetailsInfo);
      let areaIds = [];
      this.chosenProductsList.forEach((item) => {
        areaIds.push(item.areaID);
      });
      this.getCSVZoneData(areaIds);

      this.productsDetails.zones.forEach((item) => {
        const index1 = this.chosenProductsList.findIndex(
          (x) => x.zoneId == item.ZoneID
        );
        if (index1 === -1) {
          this.productsDetails.zones.splice(
            this.productsDetails.zones.findIndex(
              (el) => el.ZoneID === item.ZoneID
            ),
            1
          );
        }
      });
    }
    this.productsDetails.SurveyId = this.surveyID;
    this.productsDetails.TemplateShelfID = this.shelfID;
    this.productsDetails.Brand = this.activeBrand;
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1500);
  },
};
</script>

<style lang="scss" scoped>
.chosen-products-list {
  padding-bottom: 65px;
  .stimuli-title {
    margin-bottom: 25px;
  }
  &__wrapper {
    overflow: auto;
    width: 100%;
    padding-top: 25px;
  }
  &__row {
    display: flex;
    gap: 100px;
    margin-bottom: 24px;
    justify-content: space-between;
    position: relative;
    &--hide-line {
      &:before {
        display: none;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    &:before {
      width: 100%;
      height: 2px;
      position: absolute;
      top: 50%;
      content: "";
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23fab3c7' stroke-width='4' stroke-dasharray='11%2c 28' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    }
  }
  &__image-requirements {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
  }
  &__items {
    width: 60%;
    @media screen and (max-width: 1180px) {
      width: 100%;
      padding-right: 50px;
    }
    @media screen and (max-width: 800px) {
      width: 290px;
    }
  }
  &__image {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
    }
  }
  &__image-cta {
    font-size: 11px;
    position: relative;
    color: #1c7dd6;
    padding: 2px 5px;
    border-radius: 4px;
    font-weight: 500;
    margin-top: 6px;
    svg {
      margin-right: 1px;
    }
  }
  &__items-cta {
    margin: 20px 0 30px;
  }
  &__delete-test {
    font-size: 19px;
    text-decoration: underline;
    cursor: pointer;
    position: absolute;
    top: 1px;
    right: 1px;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--red);
    transition: background 0.25s ease;
    z-index: 1;
  }
  &__add-details {
    width: 94px;
    height: 100px;
    position: relative;
    background: #fafafa;
    border: 1px dashed #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 0 5px;
    &:after {
      position: absolute;
      left: 50%;
      top: 8px;
      transform: translateX(-50%);
      content: "";
      width: 32px;
      height: 32px;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 312.602 312.602' style='enable-background:new 0 0 312.602 312.602' xml:space='preserve'%3E%3Cpath style='fill:%23000002' d='M251.52 137.244c-3.966 0-7.889.38-11.738 1.134-1.756-47.268-40.758-85.181-88.448-85.181-43.856 0-80.964 32.449-87.474 75.106C28.501 129.167 0 158.201 0 193.764c0 36.106 29.374 65.48 65.48 65.48h54.782c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5H65.48c-27.835 0-50.48-22.645-50.48-50.48 0-27.835 22.646-50.48 50.48-50.48 1.367 0 2.813.067 4.419.206l7.6.658.529-7.61c2.661-38.322 34.861-68.341 73.306-68.341 40.533 0 73.51 32.977 73.51 73.51 0 1.863-.089 3.855-.272 6.088l-.983 11.968 11.186-4.367a45.863 45.863 0 0 1 16.747-3.151c25.409 0 46.081 20.672 46.081 46.081 0 25.408-20.672 46.08-46.081 46.08-.668 0-20.608-.04-40.467-.08-19.714-.04-39.347-.08-39.999-.08-4.668 0-7.108-2.248-7.254-6.681v-80.959l8.139 9.667a7.497 7.497 0 0 0 10.567.907 7.498 7.498 0 0 0 .907-10.567l-18.037-21.427c-2.272-2.699-5.537-4.247-8.958-4.247-3.421 0-6.686 1.548-8.957 4.247l-18.037 21.427a7.498 7.498 0 0 0 .907 10.567 7.466 7.466 0 0 0 4.826 1.763 7.482 7.482 0 0 0 5.741-2.67l7.901-9.386v80.751c0 8.686 5.927 21.607 22.254 21.607.652 0 20.27.04 39.968.079 19.874.041 39.829.081 40.498.081 33.681 0 61.081-27.4 61.081-61.08 0-33.681-27.401-61.081-61.082-61.081z'/%3E%3C/svg%3E")
        center center no-repeat;
      z-index: 1;
      pointer-events: none;
    }
  }
  &__add-details-info {
    display: block;
    max-width: 100px;
    margin: 0 auto;
    text-align: center;
    font-size: 11px;
    color: #3d3d3d;
    line-height: 14px;
    margin-top: 32px;
  }
  .active-col-bcg {
    background: #f2f2f2 !important;
  }
}

::v-deep .custom-table {
  thead {
    border-color: #fff;
  }
  tbody tr {
    border-color: #fff;
    td {
      &:nth-child(2) {
        width: 100px;
      }
      &:nth-child(3) {
        min-width: 230px;
      }
    }
  }
}

.image-requirements {
  padding: 10px 0;
  &__row {
    margin-bottom: 33px;
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 40px;
    &:last-child {
      padding-bottom: 0;
      margin-bottom: 20px;
      border-bottom: 0;
    }
    > p {
      color: black;
      font-size: 16px;
      font-weight: 300;
    }

    h2 {
      font-size: 15px;
      font-weight: 400;
      margin: 25px 0 10px;
    }
  }
  &__item {
    height: 100%;
    border: 1px solid #00d1b2;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    overflow: hidden;
    p {
      text-align: center;
      padding: 10px;
      line-height: 18px;
      font-size: 13px;
      flex: 1;
    }
    &--red {
      border-color: #ff3860;
      .image-requirements__item-category,
      .image-requirements__item-dimensions {
        background: #ff3860;
      }
    }
    &--transparent-info {
      background: #d0d0d0;
      border-width: 0;
      padding-bottom: 10px;
      .image-requirements__item-image {
        padding-bottom: 56.7%;
        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
        }
      }
    }
  }
  &__item-category {
    background: #00d1b2;
    color: #fff;
    text-align: center;
    padding: 3px;
    margin-bottom: 10px;
  }
  &__item-image {
    padding-bottom: 100%;
    position: relative;
    img {
      max-width: 100%;
      border-radius: 3px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      height: 90%;
      object-fit: contain;
    }
  }
  &__item-dimensions {
    background: #00d1b2;
    color: #fff;
    text-align: center;
    span {
      padding: 5px;
      display: flex;
      align-items: center;
      font-size: 13px;
      justify-content: center;
      &:first-child {
        border-right: 1px solid #c3ede4;
      }
    }
  }
}
</style>
